
import { Navigation } from "swiper";

import CarouselImage from "./CarouselImage";

export default {
  components: { CarouselImage },

  props: {
    gallery: { type: Array, default: () => {} },
    index: { type: Number, default: 0 },
    primary: { type: Object, default: () => {} },
    getImage: { type: Function, default: () => {} },
  },

  data() {
    return {
      dataIndex: this.index,
      text: {},
    };
  },

  computed: {
    swiperOptions() {
      return {
        slidesPerGroup: 1,
        slidesPerView: "auto",
        initialSlide: this.index,
        loop: true,
        loopFillGroupWithBlank: false,
        modules: [Navigation],
        navigation: {
          nextEl: ".instagram-m-modal-swiper-next",
          prevEl: ".instagram-m-modal-swiper-prev",
        },
      };
    },
    slideVisible() {
      return this.gallery[this.dataIndex];
    },
  },

  async mounted() {
    await this.$swiper.init(".swiper.mobile-instagram", this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(".swiper.mobile-instagram");
  },
};
